import { Component } from '@angular/core';
import { Store } from '@ngrx/store';

import { selectOrgName } from 'app/_state/org-context/org-context-selectors';
import { OrgContextState } from 'app/_state/org-context/org-context-state';

@Component({
  selector: 'app-logo',
  template: `
  <svg class="header__logo" viewBox="0 0 111 39.96">
    <use xlink:href="#ab-logo"></use>
  </svg>
  <svg class="header__logo header__logo--sm" viewBox="0 0 27.77 40">
    <use xlink:href="#ab-mark"></use>
  </svg>
  <div class="header__org"><span>{{organizationName$ | async}}</span></div>
  `
})
export class LogoComponent {
  organizationName$ = this.store.select(selectOrgName);
  constructor(private store: Store<OrgContextState>) {
  }
}
